<template>
    <div>
        <h2 class="text-center thank-you-heading">Verify OTP</h2>
        <p
            class="text-center paragraph"
            style="padding: 0px icon-customer-profil30px"
        >
            Please verify the OTP sent to your e-mail address
        </p>
        <b-form-group id="input-group-1" label="otp-code" label-for="otpcode">
            <b-form-input
                id="otpcode"
                v-model="otpCode"
                v-validate="{ required: true, max: 6, regex: /^([0-9]*)$/ }"
                type="text"
                required
                name="OTP code"
                autocomplete="no"
                placeholder="Enter OTP code"
            ></b-form-input>
            <span v-if="isError" class="text-center color-red">{{
                isError
            }}</span>
        </b-form-group>
        <div class="row">
            <div class="col-12">
                <div class="row justify-content-center">
                    <!-- <b-button
                        type="button"
                        variant="primary"
                        class="primary-add-btn"
                        @click="initRecaptcha"
                    >
                        <span class="btn-text"
                            ><span v-if="countDown > 0">Submit</span
                            ><span v-else>Resend Code</span></span
                        >
                    </b-button> -->
                    <popup-button
                        btn-type="button"
                        btn-variant="primary"
                        :btn-label="
                            countDown > 0 ? 'Submit OTP' : 'Resend Code'
                        "
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                        @onClickButton="submitOTP"
                    >
                        <!-- <span class="btn-text"
                            ><span v-if="countDown > 0">Submit</span
                            ><span v-else>Resend Code</span></span
                        > -->
                    </popup-button>
                </div>
            </div>
        </div>
        <p
            v-if="countDown > 0"
            class="text-center paragraph fs-13 my-3"
            style="padding: 0px icon-customer-profil30px"
        >
            Resend Code in {{ countDown }} seconds
        </p>
        <!-- <p
            class="text-center paragraph fs-13 my-3"
            style="padding: 0px icon-customer-profil30px"
        >
            I agree to <a href="www.google.com">Terms and Policies</a>
        </p> -->
        <b-modal
            ref="modalRecaptcha"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header-close="true"
        >
            <div class="col-sm-10">
                <recaptcha @onVerify="onVerify"> </recaptcha>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Recaptcha from '@/components/registration/Recaptcha.vue'
import request from '@/utils/request'
import PopupButton from '@/components/registration/PopupButton.vue'
import { mapGetters } from 'vuex'
import jwt_decode from 'jwt-decode'

export default {
    components: {
        Recaptcha,
        PopupButton,
    },

    props: {
        data: { type: Object },
    },
    data() {
        return {
            otpCode: '',
            resendDisable: true,
            countDown: 120,
            responseData: '',
            isError: '',
            recaptchaResponse: '',
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        // ...mapState({
        //     userOcr: (state) => state.registration.useOcr,
        // }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */

    mounted() {
        this.countDownTimer()
        //console.log('PropsData: ' + JSON.stringify(this.data))
    },
    methods: {
        async onVerify(response) {
            if (response) {
                this.recaptchaResponse = response
                // this.$refs.modalRecaptcha.hide()
                this.submitOTP()
            }
        },

        async initRecaptcha() {
            if (this.countDown > 0) {
                const result = await this.$validator.validateAll()

                if (result) {
                    this.$refs.modalRecaptcha.show()
                }
            } else {
                this.submitResend()
            }
        },

        async submitOTP() {
            this.$store.commit('setLoading', true)

            const result = await this.$validator.validateAll()

            if (result) {
                const formData = {
                    otpCode: this.otpCode,
                    token: this.data.data.token,
                    // mobileNo: this.data.data.phoneNumber,
                    // cToken: this.recaptchaResponse,
                    // customerData :  this.$store.state.registration.form,
                    // dataSegmentId : this.dataSegmentId
                }

                // formData.customerData = this.$store.state.registration.form
                // formData.customerData.dataSegmentId = this.dataSegmentId

                let encryptedForm = this.CryptoJS.AES.encrypt(
                    JSON.stringify(formData),
                    process.env.VUE_APP_CRYPTO_SECERT_KEY
                ).toString()
                //console.log('encrypt: ' + encryptedForm)
                const response = await request({
                    url: `/configurations/verify-otp`,
                    method: 'post',
                    data: { data: encryptedForm },
                })

                if (response.status == 200) {
                    // this.$emit('verificationStatus', data.data)

                    // if (data.data.verificationStatus == false) {
                    //     this.isError = data.data.message
                    // }
                    // const decodedToken = jwt_decode(data.data.token);
                    this.$emit('verificationStatus', response)
                    // if (data.data.verificationStatus == false) {
                    //     this.isError = data.data.message;
                    // }
                    if (response.status != 200) {
                        this.isError = 'Your code is invalid, try again!'
                    } else {
                        this.isError = ''
                    }

                    this.$store.commit('setLoading', false)
                } else {
                    this.$store.commit('setError', this.errors.all()[0])
                    this.$store.commit('setLoading', false)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
                this.$store.commit('setLoading', false)
            }
        },

        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                this.isError =
                    'Your OTP code is expired, please click resend OTP'
                this.resendDisable = false
            }
        },
        submitResend() {
            this.$emit('reSendOTP', '')
            this.initCountDown()
        },
        initCountDown() {
            this.countDown = 120
            this.countDownTimer()
            this.isError = null
        },
    },
}
</script>
<style scoped>
p {
    margin: 0;
    font-size: 16px;
    padding: 0px 20px;
}

.icon-tick-with-circle {
    color: green;
    font-size: 30px;
    cursor: pointer;
}
</style>
